import { render } from "./MagicLogin.vue?vue&type=template&id=5b48b1c2&scoped=true&lang=pug"
import script from "./MagicLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./MagicLogin.vue?vue&type=script&setup=true&lang=js"

import "./MagicLogin.vue?vue&type=style&index=0&id=5b48b1c2&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b48b1c2"]])

export default __exports__